<div class="overview-section">
  <div class="overview-heading-wrapper">
    <p class="overview-label">Real-Time Purchase Visibility</p>
    <h2 class="overview-heading">Every Order, Tracked to Payment</h2>
    <p class="overview-subtitle">
      Order volume, total value, invoiced vs. outstanding, and your top vendors by spend —
      all live, on one dashboard.
    </p>
  </div>

  <div class="overview-frame">
    <img src="images/modules/analysis.PNG" alt="orderYaa Procurement Purchase Analysis dashboard showing order value, invoiced, outstanding, and top vendors by spend" />
  </div>
</div>
